<template>
  <!-- SENSOR LIST -->
  <div class="sensor-list">
    <div class="bridge-vect-draw" :style="{ width: this.nSpans * 300 + 'px' }">
      <div
        class="tooltip"
        v-for="sensor in sensors"
        v-bind:key="sensor.eui"
        width="64px"
        height="64px"
        :style="{
          marginTop: sensor.bridgeSide * 80 + 10 + 'px',
          marginLeft: (sensor.bridgeSpan / 10) * 290 + 35 + 'px',
        }"
      >
        <button
          v-if="sensor.type === 'deck'"
          v-bind:class="[checkIfSelected(sensor) ? 'selected-button' : '', 'button']"
          @click="selectSensorHandler(sensor)"
        >
          {{ sensor.eui.substr(sensor.eui.length - 4) }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sensor-list",
  data() {
    return {
      selectedSensors: [],
    };
  },
  props: {
    sensors: Array,
    nSpans: Number,
    selectedDefault: Array,
    single: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    sensors: function (newSensors) {
      this.selectedSensors = [newSensors[0]];
    },
    selectedDefault: function (sensors) {
      this.selectedSensors = sensors;
    },
  },
  methods: {
    /* Verifica se il sensor 'sensor' è tra i selezionati nell'array 'selectedSensors" */
    checkIfSelected(sensor) {
      let check = false;
      for (let selectedSensor of this.selectedSensors) {
        if (sensor.eui == selectedSensor.eui) {
          check = true;
          break;
        }
      }
      return check;
    },
    selectSensorHandler(sensor) {
      if (!this.single) {
        for (let selectedSensor of this.selectedSensors) {
          // Se era già selezionato -> lo deseleziono
          if (sensor.eui == selectedSensor.eui) {
            this.selectedSensors = this.selectedSensors.filter(function (item) {
              return item !== sensor;
            });
            this.$emit("sensors-selected", this.selectedSensors);
            return;
          }
        }
        // Altrimenti lo seleziono
        this.selectedSensors.push(sensor);
      } else {
        this.selectedSensors.splice(0, 1, sensor);
      }
      this.$emit("sensors-selected", this.selectedSensors);
    },
  },
  mounted() {
    if (!this.single) this.selectedSensors = this.sensors;
    else this.selectedSensors.splice(0, 1, this.sensors[0]);
  },
};
</script>
<style scoped>
.sensors-container {
  width: 640px;
  top: 0;
  left: 0;
  position: relative;
}
.bridge-vect-draw {
  height: 150px;
  background-color: rgba(80, 84, 105, 1);
  border-radius: 10px;
  display: flex;
}
.tooltip {
  font-size: smaller;
  position: absolute;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.2s linear, opacity 0.2s linear;
  transition-delay: 0s;

  width: 180px;
  background-color: black;
  color: #fff;
  text-align: left;
  border-radius: 1px;
  padding: 1px 12px;
  position: absolute;
  z-index: 1;
  bottom: 110%;
  left: 10%;
  margin-left: -7vw;
  font-family: monospace;
}

.tooltip:hover > .tooltiptext {
  visibility: visible;
  opacity: 0.88;
  transition-delay: 1s;
}

.button {
  display: inline-block;
  padding: 9px 22px;
  font-size: 1.2em;
  font-weight: 700;
  cursor: crosshair;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: rgb(80, 84, 105);
  border: solid 5px white;
  border-radius: 10px;
  transition: transform 0.1s linear;
}
.sensor-list {
  justify-items: center;
  text-align: left;
  width: 93%;
  height: 180px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  display: grid;
  align-items: center;
  /*   display: flex;
  align-items: center; */
  /*   display: grid;
  align-items: center; */
}

/* Tra 600 e 1499 */
@media all and (max-width: 1499px) and (min-width: 300px) {
  .sensor-list {
    height: 160px;
  }
  .bridge-vect-draw {
    height: 150px;
  }
  .button {
    font-size: 1em;
    padding: 8px 18px;
    border: solid 3px white;
  }
}
.selected-button {
  background-color: rgb(35, 145, 254);
}

.button:hover {
  /*   background-color: rgb(47, 112, 177); */
  transition: transform 0.1s linear;
  -ms-transform: scale(1.1); /* IE 9 */
  -webkit-transform: scale(1.1); /* Safari 3-8 */
  transform: scale(1.1);
}

.button:active {
  background-color: rgb(47, 112, 177);
  transform: translateY(1px);
}
</style>
